var _path, _path2, _path3, _path4, _path5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfmask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_869_4990)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2729 22.6928H8.58767C8.01826 22.6928 7.55664 22.1734 7.55664 21.5329V7.614C7.55664 6.97342 8.01826 6.4541 8.58767 6.4541H15.5237L20.3039 11.8319V21.5329C20.3039 22.1734 19.8422 22.6928 19.2729 22.6928Z",
    fill: "url(#paint0_linear_869_4990)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_869_4990)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1007 14.5205H9.75879V18.9492H18.1007V14.5205Z",
    fill: "#E85555",
    fillOpacity: 0.24
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9775 13.1588V12.3126C10.9775 11.9064 11.2702 11.5771 11.6312 11.5771H16.2288C16.5899 11.5771 16.8825 11.9064 16.8825 12.3126V13.1588V13.7834V14.7405V15.3651V16.3222V16.9468V17.9039V18.5285V19.3747C16.8825 19.7809 16.5899 20.1102 16.2288 20.1102H11.6312C11.2702 20.1102 10.9775 19.7809 10.9775 19.3747V18.5285V17.9039V16.9468V16.3222V15.3651V14.7405V13.7834V13.1588Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.8223V15.1523H10.996C11.1874 15.1523 11.3505 15.191 11.4853 15.2684C11.6201 15.3448 11.7228 15.4513 11.7935 15.5878C11.8649 15.7234 11.9007 15.8798 11.9007 16.0571C11.9007 16.2344 11.8645 16.3909 11.7922 16.5265C11.7199 16.662 11.6151 16.7676 11.4779 16.8433C11.3415 16.9189 11.1763 16.9567 10.9824 16.9567H10.3476V16.5043H10.8961C10.9988 16.5043 11.0835 16.4856 11.15 16.4482C11.2174 16.41 11.2675 16.3574 11.3004 16.2905C11.3341 16.2227 11.3509 16.1449 11.3509 16.0571C11.3509 15.9685 11.3341 15.8911 11.3004 15.825C11.2675 15.7581 11.2174 15.7064 11.15 15.6699C11.0826 15.6325 10.9972 15.6139 10.8936 15.6139H10.5337V17.8223H10ZM13.3852 17.8223H12.4903V15.1523H13.3926C13.6465 15.1523 13.8651 15.2058 14.0483 15.3127C14.2316 15.4187 14.3725 15.5713 14.4711 15.7703C14.5705 15.9693 14.6203 16.2075 14.6203 16.4847C14.6203 16.7629 14.5705 17.0019 14.4711 17.2018C14.3725 17.4017 14.2308 17.5551 14.0459 17.662C13.8618 17.7689 13.6416 17.8223 13.3852 17.8223ZM13.024 17.3387H13.363C13.5208 17.3387 13.6535 17.3091 13.7611 17.25C13.8696 17.19 13.951 17.0975 14.0052 16.9723C14.0603 16.8463 14.0878 16.6838 14.0878 16.4847C14.0878 16.2874 14.0603 16.1262 14.0052 16.001C13.951 15.8759 13.87 15.7838 13.7624 15.7247C13.6547 15.6656 13.522 15.636 13.3642 15.636H13.024V17.3387ZM15.2586 17.8223V15.1523H16.93V15.6178H15.7923V16.254H16.8191V16.7194H15.7923V17.8223H15.2586Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_869_4990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 14,
    height: 17
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2729 22.6927H8.58767C8.01826 22.6927 7.55664 22.1735 7.55664 21.533V7.61401C7.55664 6.9734 8.01826 6.4541 8.58767 6.4541H15.5237L20.3039 11.8319V21.533C20.3039 22.1735 19.8422 22.6927 19.2729 22.6927Z",
    fill: "url(#paint1_linear_869_4990)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_869_4990)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M7.34541 17.21C13.1302 17.21 17.8197 12.1467 17.8197 5.90089C17.8197 -0.344949 13.1302 -5.4082 7.34541 -5.4082C1.5606 -5.4082 -3.12891 -0.344949 -3.12891 5.90089C-3.12891 12.1467 1.5606 17.21 7.34541 17.21Z",
    fill: "url(#paint2_linear_869_4990)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M7.34526 12.9921C10.9818 12.9921 13.9298 9.81723 13.9298 5.90083C13.9298 1.98444 10.9818 -1.19043 7.34526 -1.19043C3.70873 -1.19043 0.760742 1.98444 0.760742 5.90083C0.760742 9.81723 3.70873 12.9921 7.34526 12.9921Z",
    fill: "url(#paint3_linear_869_4990)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_869_4990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3037 11.8319H19.1188C17.1331 11.8319 15.5234 10.0209 15.5234 7.78705V6.4541L20.3037 11.8319Z",
    fill: "url(#paint4_linear_869_4990)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_869_4990",
    x: -29.2412,
    y: -24.4795,
    width: 86.3418,
    height: 82.4287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_869_4990"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_869_4990",
    x: -7.47656,
    y: -17.5459,
    width: 54.7803,
    height: 55.3779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_869_4990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_869_4990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_869_4990",
    x1: 13.9303,
    y1: 6.4541,
    x2: 13.9303,
    y2: 22.6928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5221F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_869_4990",
    x1: 13.9303,
    y1: 6.4541,
    x2: 13.9303,
    y2: 22.6927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EBC89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA473"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_869_4990",
    x1: 8.10591,
    y1: 6.28952,
    x2: 11.9976,
    y2: 15.4705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_869_4990",
    x1: 7.82335,
    y1: 6.14451,
    x2: 10.2593,
    y2: 11.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_869_4990",
    x1: 17.9136,
    y1: 6.4541,
    x2: 17.9136,
    y2: 11.8319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5221F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_869_4990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.652344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfmask);
export default __webpack_public_path__ + "static/media/pdfmask.ae7e024fc413c34b5c09f3773a4e3415.svg";
export { ForwardRef as ReactComponent };